export interface ICompositeScore {
    acceptsAnyAnatomy: boolean,
    waitlistDeclineRatio: number,
    familyVoucherDonations: number,
    familyVoucherRedeemedDonations: number,
    standardVoucherDonations: number,
    compatibleTransplants: number,
    remoteCompatibleDonors: number,
    anyAnatomyDeclineRatioBonus: number,
    compositeScore: number
}